import Vue from 'vue'
import Router from 'vue-router'
import AboutUs from '@/vew/aboutUs'
import Partner from '@/vew/partner'
import JoinUs from '@/vew/joinUs'
import AllStores from '@/vew/allStores'
import ServiceCenter from '@/vew/serviceCenter'
import ProductDisplay from '@/vew/productDisplay'
import Home from '@/vew/home'


Vue.use(Router)
// const routerPush = Router.prototype.push
// Router.prototype.push = function push(location) {
//     return routerPush.call(this, location).catch(error=> error)
// }

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
	{
	  path: '/AboutUs/:id',
	  name: 'AboutUs',
	  component: AboutUs
	},
	{
	  path: '/Partner/:id',
	  name: 'Partner',
	  component: Partner
	},
	{
	  path: '/JoinUs',
	  name: 'JoinUs',
	  component: JoinUs
	},
	{
	  path: '/AllStores/:id',
	  name: 'AllStores',
	  component: AllStores
	},
	{
	  path: '/ServiceCenter',
	  name: 'ServiceCenter',
	  component: ServiceCenter
	},
	{
	  path: '/ProductDisplay/:id',
	  name: 'ProductDisplay',
	  component: ProductDisplay
	}
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js